var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "menu"
  }, [_c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v(" (function (m, e, t, r, i, k, a) { m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) }; m[i].l = 1 * new Date(); k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a) }) (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\"); ym(54162619, \"init\", { clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: true }); ")]), _vm._m(0), _c('div', {
    staticClass: "main-nav-container"
  }, [_vm.categories ? _c('ul', {
    staticClass: "main-nav"
  }, _vm._l(_vm.categories, function (category) {
    return _c('li', {
      key: 'category-' + category.id
    }, [_c('router-link', {
      class: {
        active: _vm.active === category.code
      },
      attrs: {
        "to": '/category/' + category.code,
        "data-color": category.color
      }
    }, [_vm._v(_vm._s(category.name) + " ")])], 1);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "sub-nav-container"
  }, [_c('ul', {
    staticClass: "sub-nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("О сервисе")])], 1), _vm._m(1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/feedback"
    }
  }, [_vm._v("Контакты")])], 1)])]), _c('div', {
    staticClass: "menu-copyright"
  }, [_vm._v(" © Любое использование либо копирование материалов сайта, элементов дизайна и оформления допускается лишь с письменного разрешения правообладателя и при указании ссылки на первоисточник ")])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('noscript', [_c('div', [_c('img', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "src": "https://mc.yandex.ru/watch/54162619",
      "alt": ""
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "rel": "nofollow",
      "href": "/oferta.pdf"
    }
  }, [_vm._v("Оферта")])]);
}]

export { render, staticRenderFns }